import http from "./http";

/**
 * Tabela genérica de preferências por usuário (key/value JSON).
 * Endpoint: /api/user-preferences/{key}
 *
 * Convenções de keys conhecidas:
 *   - dashboard_cards_order  → string[] de ids de cards na ordem desejada
 */

export async function getPreference(key) {
  try {
    const { data } = await http.get(`/api/user-preferences/${key}`);
    return data?.status === "success" ? data.value ?? null : null;
  } catch (err) {
    console.error(`Erro ao ler preference ${key}:`, err);
    return null;
  }
}

export async function savePreference(key, value) {
  try {
    const { data } = await http.put(`/api/user-preferences/${key}`, { value });
    return data?.status === "success";
  } catch (err) {
    console.error(`Erro ao salvar preference ${key}:`, err);
    return false;
  }
}

// Constantes de keys para evitar typos
export const PREF_KEYS = {
  DASHBOARD_CARDS_ORDER: "dashboard_cards_order",
};
